<template>
  <div class="banner banner--warning" v-show="globalStore.showBanner" v-cloak ref="bannerWrapper">
    <span v-html="props.bannerData ? props.bannerData.content : ''"></span>
    <a href="#" class="banner__close" @click.prevent="closeBanner"><i class="icon icon--cross"></i></a>
  </div>
</template>
<script setup>
import { ref, onMounted, onBeforeMount } from 'vue';
import useGlobalStore from '../../store/globalStore'

const props = defineProps({
  bannerData: Object,
});

const globalStore = useGlobalStore()
const bannerWrapper = ref(null)

const closeBanner = () => {
  globalStore.showBanner = false;
  const bannerClosedArray = localStorage.getItem('bannerClosedData')
    ? JSON.parse(localStorage.getItem('bannerClosedData'))
    : [];
  bannerClosedArray.push(props.bannerData.id);
  localStorage.setItem('bannerClosedData', JSON.stringify(bannerClosedArray));

};

onMounted(() => {
  globalStore.bannerHeight = bannerWrapper.value.offsetHeight;
});

onBeforeMount(() => {
  const bannerClosedArray = localStorage.getItem('bannerClosedData')
    ? JSON.parse(localStorage.getItem('bannerClosedData'))
    : [];

  if (props.bannerData === undefined || bannerClosedArray.includes(props.bannerData.id)) {
    globalStore.showBanner = false;
  }

  if (window.location.href.toLowerCase().indexOf('village-research') > 0) {
    globalStore.showBanner = false;
  }
});

</script>
